export default __webpack_public_path__ + "static/media/image-4.49d1f0bf.webp";